import React from 'react'
import GettingStartedPage from '../../components/Fundraiser/FundraiserOnboarding/GettingStarted';

const GettingStarted = (props) => {
  return (
    <GettingStartedPage {...props} />
  )
}

export default GettingStarted;
